(function($, Drupal) {
  Drupal.behaviors.addHoverLinkAnimation = {
    attach: function(context, settings) {
      const linksToAnimate = [
        '.long-arrow-link',
        '.field--name-field-one-column-link a',
      ];
      $(once('animated-link-processed', $(linksToAnimate.join(',')))).each(function() {
        $(this).append('<span class="text-underline"></span>');
        $(this).addClass('is-animated');
      });
    },
  },

  Drupal.behaviors.addParagraphArrowAnimation = {
    attach: function(context, settings) {
      const self = this;
      $(once('animated-arrow-processed', '.paragraph--type--one-column-narrow-text.has-animated-arrow')).each(function() {
        $(this).find('.arrow').addClass('is-hidden');
        $(this).find('.field--name-field-text-header, .field--name-field-text-content').addClass('is-hidden');
        const options = {
          root: context,
          rootMargin: '0px',
          threshold: .5
        }
        const observer = new IntersectionObserver(self.triggerAnimation, options);
        observer.observe(this);
      });
    },
    triggerAnimation: function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          $(entry.target).find('.arrow').removeClass('is-hidden');
          $(entry.target).find('.field--name-field-text-header, .field--name-field-text-content').removeClass('is-hidden');
        }
      });
    },
  }

})(jQuery, Drupal);
